<ng-container>
    <div class="mb-4 flex flex-col items-center justify-center p-4 border border-red-200 bg-red-50 rounded">
        <div class="text-base font-semibold text-red-700 mb-2 flex items-center gap-2">
            <span class="material-icons align-middle">error_outline</span>
            Error loading content
        </div>
        <div class="text-sm text-red-600 mb-3">
            An error occurred while loading this content. Please try again later.
        </div>
        <div class="flex gap-2 cc-crud-row-actions">
            <button
                type="button"
                *ngIf="uncrashEvent?.observers?.length"
                mat-icon-button
                matTooltip="Back"
                aria-label="Back"
                (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <button
                type="button"
                mat-icon-button
                matTooltip="Refresh"
                aria-label="Refresh"
                (click)="refresh()">
                <mat-icon>refresh</mat-icon>
            </button>
            <button
                type="button"
                *ngIf="!reported"
                mat-icon-button
                matTooltip="Report this error"
                aria-label="Report this error"
                (click)="report()">
                <mat-icon>bug_report</mat-icon>
            </button>
        </div>
    </div>
</ng-container>
